<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="submit">
      <dt-modal v-model="isVisible">
        <div slot="header">
          <h4 class="modal-title">
            Change Password
          </h4>
        </div>
        <div slot="body">
          <div class="row">
            <p class="ml-2">Please supply a new password for {{ firstName }} {{ lastName }} ({{ username }}):</p>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <dt-input
                type="password"
                v-model="password"
                name="password"
                label="Password"
                autocomplete="new-password"
                validate="required"
              />
              <dt-input
                type="password"
                v-model="password2"
                name="password2"
                label="Password again"
                autocomplete="new-password"
                validate="required"
              />
            </div>
          </div>
        </div>
        <div slot="footer">
          <button
            type="button"
            class="btn btn-light"
            @click="close()"
          >Cancel</button>
          <button
            type="submit"
            class="btn btn-primary"
          >Change Password</button>
        </div>
      </dt-modal>
    </form>
  </ValidationObserver>
</template>
<script>
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import DtInput from '@/components/utilities/form/dt-input'
export default {
  name: 'change-password',
  components: {
    DtModal,
    DtInput
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      password: '',
      password2: '',
      reason: '',
      isLoading: true
    }
  },
  mounted() {
    this.isLoading = false
    let $this = this
    this.password = ''
    this.password2 = ''
    this.reason = ''
    setTimeout(function() {
      $this.password = ''
      $this.password2 = ''
      $this.reason = ''
    }, 400)
  },
  computed: {
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    firstName: {
      get() {
        let _name = ''
        if (this.value !== undefined && this.value !== null) {
          _name = this.value.firstName
        }
        return _name
      }
    },
    lastName: {
      get() {
        let _name = ''
        if (this.value !== undefined && this.value !== null) {
          _name = this.value.lastName
        }
        return _name
      }
    },
    username: {
      get() {
        let _name = ''
        if (this.value !== undefined && this.value !== null) {
          _name = this.value.username
        }
        return _name
      }
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    },
    validatePassword() {
      let valid = true
      this.reason = ''
      if (this.isLoading === false && this.password !== '') {
        if (this.password === this.password2) {
          let strongRegex = new RegExp(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
          )
          valid = strongRegex.test(this.password)
          if (valid === false) {
            this.reason =
              "Password doesn't meet minimum strength of special characters (!@#$%^&*), lower case (a-z), upper case (A-Z) and numbers (0-9), and at least 8 characters in length."
          }
        } else {
          this.reason = "Passwords don't match."
          valid = false
        }
      }
      return valid
    },
    async submit() {
      this.$refs.form.validate().then(async success => {
        if (success) {
          if (this.validatePassword()) {
            let data = {
              contact: this.value.contact,
              userid: this.value.user,
              password: this.password
            }
            this.$emit('send', data)
          } else {
            alert(this.reason)
          }
        } else {
          alert('Please supply a password.')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/forms/user-password.vue